webpackJsonp([279967065267770],{

/***/ 752:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactAccessibleAccordion = __webpack_require__(38);
	
	var _reactYoutube = __webpack_require__(28);
	
	var _reactYoutube2 = _interopRequireDefault(_reactYoutube);
	
	__webpack_require__(752);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BGvideoOptions = {
	    height: '500',
	    width: '100%',
	    playerVars: { // https://developers.google.com/youtube/player_parameters
	        autoplay: 1,
	        controls: 0,
	        rel: 0,
	        showinfo: 0,
	        modestbranding: 1, // Hide the Youtube Logo
	        loop: 1, // Run the video in a loop - DOESN'T WORK - used onEnd function
	        fs: 0, // Hide the full screen button
	        cc_load_policy: 0, // Hide closed captions
	        iv_load_policy: 3, // Hide the Video Annotations
	        autohide: 0,
	        enablejsapi: 0
	    }
	};
	
	var Challenges = function Challenges(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Challenges :: DeltaHacks 5'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'The DeltaHacks Triangle and Sponsor Challenges' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'chalbg' },
	            _react2.default.createElement(
	                _reactAccessibleAccordion.Accordion,
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    '\u25B3 Triangle Challenges'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'box' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'What are the Triangle Challenges?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'DeltaHacks is a hackathon for social change, and completing one of the Triangle Challenges is a great way to make sure your hack makes a difference.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'What\'s in it for me?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Apart from the satisfaction of your hack being used in real life, all hacks entered will also become part of the prize pool for the Triangle Challenges. The top 3 hacks in the prize pool will be awarded prizes! For details on the prizes available, check out the event ',
	                        _react2.default.createElement(
	                            'u',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: '/devpost' },
	                                'DevPost'
	                            )
	                        ),
	                        '!',
	                        _react2.default.createElement('br', null)
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ Donation Shop Webpage - Food4Kids'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Food4Kids is looking for a webpage that will offer donors the ability to purchase specific items that will go into bags for the children to receive.  Ideally this will be one page that acts as a grocery store for donors to pick and choose their items. ',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'code',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://drive.google.com/file/d/1GQzZtKRNTsirJO_f0LV2wV1rkrYKHYP-/view?usp=sharing' },
	                                    'Specifications'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'For more information, contact Tom Flood on Slack or by email: tom@food4kids.ca '
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ Wifi Security Hack - EzSec'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'EzSec will bring a high-performance R1 unit (r1secure.com) and give whoever is able to hack it a prize.  Ezzeldin Tahoun will guide participants in how to penetration test the device.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'For more information, contact Ezzeldin Tahoun on Slack or by email: tahoune@mcmaster.ca '
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ Mac Pump App - McMaster University'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Dr. Maria E. Calvo B. MD. would like you to develop an application that makes it easy for physicians to communicate with and log data on their patients useing intrathecal pumps.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'code',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://drive.google.com/file/d/1Y37UloYOfHXbH5q82mNcfkXU_AqaUvU0/view?usp=sharing' },
	                                    'Specifications'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'For more information, contact Maria Calvo on Slack or by email: marucalvo822@yahoo.com'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ Digitising Construction'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Other than a few technologies that have seeped into the industry, the shortage of finding, hiring, and screening skilled labor is still very much a problem and a huge opportunity to explore.  As a seasoned individual within the construction domain, Royston would like to challenge teams to find a way to connect employers and talent within the constuction indursty.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'code',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://drive.google.com/file/d/1YfEOQRlbESs10vDwbeDBzr-Eeg5Y84F6/view?usp=sharing' },
	                                    'Specifications'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'For more information, contact Royston Rebello on Slack or by email: roystonarebello@gmail.com'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ Health Challenge - McMaster University'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Om is offering an additional $100 prize for the team who wins this challenge.  20-30% of all men and 10-15% of all women in North America are affected by Sleep Apnea, a condition wherin a person stops breathing during sleep.  This can cause discomfort and disrupt sleep paterns.  Om and Shriksha have built a functional prototype and collected data on healthy volunteers, but they want your help to develop a an application to detect changes in sleep patterns, useage of MLH hardware is accepted and encouraged.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'code',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://drive.google.com/file/d/10IP319tSRL21ujhGYyZHcyUqSoGx0MyH/view?usp=sharing' },
	                                    'Specifications'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'For more information, contact Om Bhatt on Slack or by email: om.bhatt@medportal.ca'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ Exercise for the Community - McMaster University'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Dr. Curnew\'s Cardiology Clinic wants you to develop an app that simply makes it easy, convenient, and fun for people in your community to connect and plan physical activities together.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'code',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://drive.google.com/file/d/1UMInygFA2XizX53Df2yNvFyx7PdU9nYC/view?usp=sharing' },
	                                    'Specifications'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'For more information, contact Maggie Hou on Slack or by email: houy14@mcmaster.ca'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ Community Engagement Tracking App - United Way'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Every year UWHH raises millions of dollars in order to invest in a wide range of social services across Hamilton & Halton. This is primarily done by investing over 153 programs across 82 agencies, or non-profit charitable partners. One of the key ways to raise money is through workplace campaigns. These involve building relationships with companies of all different sizes and providing a wide range of engagement and volunteers opportunities, or Days of Caring. Days of Caring are an important part of how we communicate the impact of donations. During campaign season, the logistics of managing these opportunities across hundreds of companies and dozens of managers (RDMs), can prove challenging. UWHH is looking for an app based solution that can help us coordinate the offering across multiple people, locations, and agencies. Details about what kind of information can be found below. We are also interested in gamifying the process as DOC opportunities are scarce and account managers (RDMS) put in request that can be hard to accommodate. Each manager believes their account to be the most important and we hope to introduce some limits and guidelines on who can request how many DOC opportunities and to begin building out a database that can help us track the impact of DOCS on donations. By introducing a point system based on criteria such as account size, specific departments, previous DOC usage, etc., we hope to create an internal marketplace for DOC that will allow RDM\u2019s to choose, trade, and swap these opportunities and thus reduce the difficulty of allocating the resources in a constrained market. The impact of this would be substantial as understanding the impact of DOC can help UWHH become much more strategic about the use of this powerful experience and generate more donations and therefore impact the lives of more people.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'For more information, contact Corinne Roynon on Slack or by email: CRoynon@uwhh.ca'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ Social Impact App - Mission Services'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'We are requesting the development of A GALA (Gibson & Landsdale neighbourhoods) Youth Programs app featuring information about programs provided by Mission Services of Hamilton, CORE (Cathy Wever School), Pinkly Lewis Recreation Centre, 541 Eatery and Exchange, and Barton Library. These programs provide a mix of after-school activities, learning opportunities, food programs, mentoring and more to kids from low-income homes.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'code',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://drive.google.com/file/d/1hfGbSy2IavPaqzvczyKkWuJqdlps6HYr/view?usp=sharing' },
	                                    'Specifications'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        'The idea is to have an app that provides an interactive space with the following features:',
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'General information about all available programs'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Includes a space for youth to be involved by providing suggestions or comments'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Allows for youth to know programming in advance and for them to be involved in planning \u2013 provides maximum impact and ensures they get the most out of the program'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Ease of access and communication allows more youth leadership'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Provides accessible leadership development opportunities'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Can be used by youth, parents, and program leaders'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Provides a platform to interact and engage with parents as we supports kids with the resources (related to academics, nutrition, mental health, physical health, etc.)  to succeed in school and make plans for their future'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Provides general info about available programs to all users as well as a second level sign-in so that youth and parents participating in a specific program can access their specific program area'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Regarding youth user information, privacy of information is paramount'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'For more information, contact Katie Jessup on Slack or by email: kjessup@mission-services.com'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.AccordionItem,
	                    null,
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemTitle,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '+ HyperCare - Automation Challenge'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItemBody,
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Build an application that helps automate the paperwork in healthcare, either for patients, clinicians or organizations.'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	        )
	    );
	};
	
	exports.default = Challenges;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-trianglechallenges-js-574c62971c87f182c841.js